import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Maincontact from './components/contact';
import Career from './components/career';
import Service from './components/service';
import Aboutmain from './components/about';
import OurTeam from './components/ourteam';
import Careers from './components/career';
import ITproject from './components/itproject';
import ITstaffing from './components/itstaffing';
import ProjectDetails1 from './layout/servicedetails/projectdetails';
import ProjectDetails2 from './layout/servicedetails/projectdetails2';
import ItTrainingmain from './components/ittraining';
import ITcareer from './components/itcareer';
import CoursesList from './components/courses-list';
import ViewDetailsPage from './components/courseview-details';
import SignUpForm from './common/signUpform';
import Payment from './common/payment';
import Webinar from './components/webinar';
import News from './components/news';
import SocialMedia from './components/socialmedia';
import CoursesLevelList from './components/courselevel';
import Termsandconditions from './components/termsandconditions';
import RefundPolicy from './components/refundpolicy';
import BlogContent from './layout/Blogs/blogcontent';
import Teamdetails from './layout/our team/teamdetail';
import ApplyForm from './layout/career/careeedetails';
import ITInfrastructure from './components/itinfrastructure';

function usePageRefreshOnRouteChange() {
    const location = useLocation();
    const [lastPath, setLastPath] = useState(location.pathname);

    useEffect(() => {
        const currentPath = location.pathname;
        const isIDRoute = /\/projectdetails\/\d+/.test(currentPath); // Matches routes like /projectdetails/123

        if (!isIDRoute && lastPath !== currentPath) {
            setLastPath(currentPath);
            const element = document.getElementById(location.hash.replace());
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.location.reload(); // Force a page refresh
            }
            window.scrollTo(0, 0);
        } else if (isIDRoute) {
            setLastPath(currentPath); // Update the path without refreshing
        }
    }, [location, lastPath]);
}

function Main() {
    return (
        <Router>
            <PageContent />
        </Router>
    );
}

function PageContent() {
    usePageRefreshOnRouteChange(); // Use the custom hook here

    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/contact' element={<Maincontact />} />
            <Route path='/career' element={<Career />} />
            <Route path='/service' element={<Service />} />
            <Route path='/about' element={<Aboutmain />} />
            <Route path='/our-team' element={<OurTeam />} />
            <Route path='/careers' element={<Careers />} />
            <Route path='/project' element={<ITproject />} />
            <Route path='/staffing' element={<ITstaffing />} />
            <Route path='/it-career' element={<ITcareer />} />
            <Route path='/projectdetails' element={<ProjectDetails1 />} /> {/* Dynamic ID */}
            <Route path='/projectdetails2' element={<ProjectDetails2 />} />
            <Route path='/training' element={<ItTrainingmain />} />
            <Route path='/course-list' element={<CoursesList />} />
            <Route path='/course-details' element={<ViewDetailsPage />} />
            <Route path='/signup' element={<SignUpForm />} />
            <Route path='/payment' element={<Payment></Payment>} />
            <Route path='/news' element={<News></News>} />
            <Route path='/events' element={<Webinar></Webinar>} />
            <Route path='/socialmedia' element={<SocialMedia></SocialMedia>} />
            <Route path='/courselevel' element={<CoursesLevelList></CoursesLevelList>} />
            <Route path='/cancellation_and_refundpolicy' element={<RefundPolicy></RefundPolicy>} />
            <Route path='/terms_and_conditions' element={<Termsandconditions></Termsandconditions>} />
            <Route path="/Blog-details" element={<BlogContent />} />
            <Route path="/team-detail" element={<Teamdetails/>} />
            <Route path="/careerdetails-apply" element={<ApplyForm />} />
            <Route path="/infrastructure" element={<ITInfrastructure></ITInfrastructure>} />
        </Routes>
    );
}

export default Main;
